var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.36,
    height: 33.36,
    viewBox: "0 0 33.36 33.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-logo-linkedin",
    "data-name": "Icon ionic-logo-linkedin",
    d: "M35.192,4.5H7.35A2.722,2.722,0,0,0,4.5,7.1V35A2.935,2.935,0,0,0,7.35,37.86H35.184A2.786,2.786,0,0,0,37.86,35V7.1A2.558,2.558,0,0,0,35.192,4.5ZM14.841,32.307H10.061V17.448h4.779ZM12.616,15.188h-.035a2.453,2.453,0,0,1-2.52-2.563,2.468,2.468,0,0,1,2.581-2.563A2.462,2.462,0,0,1,15.2,12.625,2.468,2.468,0,0,1,12.616,15.188ZM32.307,32.307H27.528V24.182c0-1.947-.7-3.276-2.424-3.276a2.615,2.615,0,0,0-2.451,1.764,3.218,3.218,0,0,0-.165,1.173v8.464H17.709V17.448h4.779v2.068A4.838,4.838,0,0,1,26.8,17.1c3.137,0,5.509,2.068,5.509,6.526v8.681Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#919ede"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact2);
export default __webpack_public_path__ + "static/media/contact2.846d74855cf5458b7b04ad7783738bf7.svg";
export { ForwardRef as ReactComponent };